<template>
  <div class="esign-success-container" v-if="show">
    <div>
      <weex-text class="item-lg-heading">{{heading}}</weex-text>
      <weex-text class="item-sm-heading margin_top_20">{{body}}</weex-text>

      <wxc-button
        text="Continue"
        class="button_horizontal_center margin_top_20"
        size="small"
        type="blue"
        @wxcButtonClicked="onSignSuccess"
        ></wxc-button>
    </div>
  </div>
</template>

<script>

  import WxcButton from "@/../weex-ui/packages/wxc-button/index"

  export default {
    name: "EsignSuccessView",
    components: { WxcButton },
    props: {
      heading: {
        type: String,
        default: "Esign Successfull"
      },
      body: {
        type: String,
        default: "Please continue the further steps"
      },

      show: {
        type: Boolean,
        required: true,
        default: false
      }
    },
    methods: {
      onSignSuccess() {
        this.$emit("onSignSuccess");
      }
    }
  }
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
  .esign-success-container {
    margin: 20px auto;
    position: relative;
    background: #F9F9F9;
    padding: 25px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  }

</style>
